import React, { useEffect, useState } from "react";
import axios from "axios";
import { ChevronDown, ChevronUp, History, RefreshCw } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";

const VISIBLE = 5;
const clean = (v) => (v && v.trim() && v.trim() !== "-" ? v : "");

const ActivityRow = ({ item }) => (
  <tr className="border-t hover:bg-gray-50" data-testid={`staff-activity-row-${item.id}`}>
    <td className="p-2 whitespace-nowrap text-gray-600">{item.date ? new Date(item.date).toLocaleString("tr-TR", { dateStyle: "short", timeStyle: "short" }) : ""}</td>
    <td className="p-2 font-medium whitespace-nowrap">{item.user_name || "-"}</td>
    <td className="p-2 font-mono text-blue-700 whitespace-nowrap">{clean(item.serial_number) ? `#${item.serial_number}` : "-"}</td>
    <td className="p-2">{item.customer_name || "-"}</td>
    <td className="p-2 text-purple-700">{clean(item.end_customer) || "-"}</td>
    <td className="p-2">
      <span className={`mr-1 px-1.5 py-0.5 rounded text-[10px] font-semibold ${item.area === "Üretim" ? "bg-amber-100 text-amber-800" : "bg-teal-100 text-teal-800"}`}>{item.area}</span>
      {item.action}
    </td>
  </tr>
);

export const StaffActivityLog = ({ api, sessionToken, refreshKey }) => {
  const [items, setItems] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${api}/staff-activities/erp`, { params: { session_token: sessionToken, limit: 50 } });
      setItems(res.data.items || []);
    } catch (e) {
      console.error("Personel işlemleri alınamadı:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!sessionToken) return undefined;
    const t = setTimeout(load, 400);
    return () => clearTimeout(t);
  }, [sessionToken, refreshKey]);

  const shown = expanded ? items : items.slice(0, VISIBLE);
  return (
    <Card data-testid="staff-activity-log">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center justify-between text-base">
          <span className="flex items-center gap-2"><History className="h-5 w-5" /> Personelin Son İşlemleri</span>
          <Button variant="ghost" size="sm" onClick={load} disabled={loading} data-testid="staff-activity-refresh">
            <RefreshCw className={`h-4 w-4 ${loading ? "animate-spin" : ""}`} />
          </Button>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-left text-xs text-gray-600">
              <tr>
                <th className="p-2">Tarih</th><th className="p-2">Personel</th><th className="p-2">Cari Kod</th>
                <th className="p-2">Müşteri</th><th className="p-2">Nihai Müşteri</th><th className="p-2">Yapılan İşlem</th>
              </tr>
            </thead>
            <tbody>
              {shown.map((item) => <ActivityRow key={item.id} item={item} />)}
              {!loading && items.length === 0 && (
                <tr><td colSpan={6} className="p-4 text-center text-gray-500" data-testid="staff-activity-empty">Henüz işlem yok</td></tr>
              )}
            </tbody>
          </table>
        </div>
        {items.length > VISIBLE && (
          <div className="flex justify-center mt-2">
            <Button variant="outline" size="sm" onClick={() => setExpanded(!expanded)} data-testid="staff-activity-toggle">
              {expanded ? <><ChevronUp className="h-4 w-4 mr-1" /> Daha az göster</> : <><ChevronDown className="h-4 w-4 mr-1" /> Daha fazlasını listele ({items.length - VISIBLE})</>}
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
